import { getCommonAnalytics } from '../common-analytics';
import { sendLegacyGA } from '../utils/legacy-ga';

export const MARKETO_SUCCESS_EVENT = 'mhecomm-marketo-form-success';

export type MarketoSuccessDetail = {
  version: 1;
  formId: string;
  formElement: HTMLFormElement;
  componentElement: HTMLElement;
  submitLabel: string;
  successMessage: string;
  cid: string | null;
  marketoFields: {
    jobTitle: string | null;
    productInterest: string | null;
    formTitle: string | null;
  };
  authoredAnalytics: {
    satelliteId: string | null;
    gaEventName: string | null;
    gaClickName: string | null;
  };
};

const registeredTargets = new WeakSet<Document>();

export function adaptMarketoSuccess(detail: MarketoSuccessDetail): Record<string, any> {
  const payload: Record<string, any> = {
    ...getCommonAnalytics(detail.formElement),
    cid: detail.cid,
    successMessage: detail.successMessage,
    mktoJobTitle: detail.marketoFields.jobTitle ?? '',
    mktoProductInterest: detail.marketoFields.productInterest ?? '',
    mktoFormTitle: detail.marketoFields.formTitle ?? '',
    label: detail.submitLabel,
    mktoFormId: detail.formId,
    comp: 'marketo-form',
  };

  if (detail.authoredAnalytics.gaEventName) {
    payload.gaeventname = detail.authoredAnalytics.gaEventName;
  }
  if (detail.authoredAnalytics.gaClickName) {
    payload.gaclickname = detail.authoredAnalytics.gaClickName;
  }

  return payload;
}

export function emitMarketoAnalytics(detail: MarketoSuccessDetail): void {
  const payload = adaptMarketoSuccess(detail);
  try {
    const sink = window.Mhecomm?.emit;
    if (typeof sink === 'function') {
      sink('click', payload);
    }
  } catch (error) {
    console.warn('Marketo analytics delivery failed', error);
  }
  try {
    sendLegacyGA(payload);
  } catch (error) {
    console.warn('Legacy Marketo GA delivery failed', error);
  }
}

export function registerMarketoAnalytics(target: Document = document): void {
  if (registeredTargets.has(target)) return;
  target.addEventListener(MARKETO_SUCCESS_EVENT, (event: Event) => {
    emitMarketoAnalytics((event as CustomEvent<MarketoSuccessDetail>).detail);
  });
  registeredTargets.add(target);
}

if (typeof document !== 'undefined') registerMarketoAnalytics();